import { useEffect, useState } from 'react';
import { MInput } from '@Components/Base';
import { SelectedType } from '../../enums/SelectedType.enum';

interface PricingInputProps {
  priceType: string;
  handleChangeDataItem: (value: string | number) => void;
  initialValue: string | number;
  placeholder: string;
  disable: boolean;
}

const PricingInput: React.FC<PricingInputProps> = ({
  handleChangeDataItem,
  priceType,
  initialValue,
  placeholder,
  disable,
}) => {
  const [value, setValue] = useState(initialValue);
  const [prevPriceType, setUpdatePrevPriceType] = useState(priceType);

  useEffect(() => {
    if (priceType !== prevPriceType) {
      setUpdatePrevPriceType(priceType);
      setValue('');
    }
  }, [prevPriceType, priceType]);

  return (
    <MInput
      placeholder={placeholder}
      value={value}
      onChange={(e) => {
        if (priceType === SelectedType.LOI && !Number(e.target.value)) {
          return;
        }

        setValue(e.target.value);
        handleChangeDataItem(e.target.value);
      }}
      disabled={disable}
    />
  );
};

export default PricingInput;
